module.exports = __webpack_public_path__ + "static/media/icon_relate.02084a40.svg";